<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="password">
        <span slot="label">
          <a-tooltip>密码<template slot="title">密码</template></a-tooltip>
        </span>
        <a-input v-model="form.password" :maxLength="255" :placeholder="$t('请输入')+'密码'"/>
      </a-form-model-item>
      <a-form-model-item prop="avatar">
        <span slot="label">
          <a-tooltip>商户logo<template slot="title">商户logo</template></a-tooltip>
        </span>
        <oss-upload-single :height="100" :width="100"  v-model="form.avatar" prefix="merchant" type="img"/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getCustomerSeller, addCustomerSeller, updateCustomerSeller} from '@/api/customer/customerSeller'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    OssUploadSingle,
    CustomDictTag,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        avatar: null,
        password: null,
        sellerStatus: 0,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        sellerName: [{required: true, message: '商家名称' + this.$t('不能为空'), trigger: 'blur'}],
        account: [{required: true, message: '商户账号' + this.$t('不能为空'), trigger: 'blur'}],
        sellerStatus: [{
          required: true,
          message: '是否激活 1 是  0 否' + this.$t('不能为空'),
          trigger: 'blur'
        }],
        sellerId: [{required: true, message: '商户id, 来自客服系统' + this.$t('不能为空'), trigger: 'blur'}],
        sellerCode: [{
          required: true,
          message: '商户code, -来自客服系统' + this.$t('不能为空'),
          trigger: 'blur'
        }]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        avatar: null,
        password: null,
        sellerStatus: 0,
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCustomerSeller({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCustomerSeller(this.form).then(response => {
              this.$message.success(message, 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCustomerSeller(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
